import React from "react";
import { connect } from "react-redux";

import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";

import colors from "../../assets/style/colors";

import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "../Common/CloseIcon";

import SupplyChain from './assets/Supply_chain.svg';
import MeWhite from './assets/me_white.svg';

import Bento from './assets/main_menu.svg';
import Meatballs from './assets/frame_1894.svg';
import Breadcrumb from "../TopBar/Breadcrumb/Breadcrumb";
import { get } from "lodash";
import { roles } from "../../constants/roles";

const styles = {
  container: {
    height: "50px",
    width: "100%",
    backgroundColor: colors.white,
    boxShadow: `0px 0px 4px 0px ${colors.black23}`,
  },
  tabs: {
    height: "50px",
    float: "left",
    minHeight: "50px",
  },

  mobileUpperBar: {
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
  },
  buttonContainer: {
    height: "50px",
    width: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  menuButton: {
    height: "32px",
  },
  subMenuButton: {
    width: "24px",
  },

  dialogPaper: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    maxHeight: "100%",
    backgroundColor: colors.black87,
    margin: 0,
    padding: "12px",
    borderRadius: 0,
  },
  menuItem: {
    color: colors.white,
    // width: "300px",
    margin: "12px 0px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  menuItemSubpage: {
    paddingLeft: "56px",
  },
  submenuItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    color: colors.white,
    width: "300px",
    height: "48px",
    // margin: "12px 0px",
    textAlign: "right",
  },
  iconContainer: {
    minWidth: "24px",
    display: "flex",
    justifyContent: "center",
    marginRight: "8px",
  },
  menuIcon: {
    height: "20px"
  },
  btnContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  submenuCloseIconContainer: {
    marginBottom: "24px",

  }
};


const VMIMobileTopBar = (props) => {
  const menu = [
    {
      name: I18n.get("sidebar_supplychain"),
      enabled: roles.user,
      icon: SupplyChain
    },
    {
      name: I18n.get("sidebar_orders"),
      url: "/wms/requests_orders/requests",
      enabled: roles.user,
      subpage: true,
    },
    {
      name: I18n.get("sidebar_vmi_config"),
      url: "/vmi-selector",
      enabled: roles.customerAdmin,
      subpage: true,
    },
    {
      name: I18n.get("sidebar_lookup"),
      url: "/wms/lookup",
      enabled: roles.user,
      subpage: true,
    },
    {
      name: I18n.get("wms_inventory"),
      url: "/wms/inventory",
      enabled: roles.customerAdmin,
      subpage: true,
    },
    {
      name: I18n.get("sidebar_po_search"),
      url: "/wms/po-search",
      enabled: roles.customerAdmin,
      subpage: true,
    },
    {
      name: I18n.get("sidebar_me"),
      url: "/profiles/me",
      enabled: roles.customerAdmin,
      icon: MeWhite,
    }
  ];

  const submenu = [
    {
      name: I18n.get("vmi_requests"),
      url: "/wms/requests_orders/requests",
    },
    {
      name: I18n.get("vmi_orders"),
      url: "/wms/requests_orders/orders",
    },
  ];
  
  const { classes, history } = props;
  
  const [open, setOpen] = React.useState(false);
  const [openSubmenu, setOpenSubmenu] = React.useState(false);

  
  const changeTab = (newValue) => {
    history.push(newValue)
    // props.history.go()
    // window.location.reload(true)
  };

  const level = get(props, ["userRole", "level"]);

  return (
    <Grid container className={classes.container}>

        <div className={classes.mobileUpperBar}>
          {/* <img src={Add} alt="Add Order Request" onClick={() => setOpenSearch(true)}/> */}
          <div className={classes.buttonContainer} onClick={() => setOpen(true)}>
            <img src={Bento} className={classes.menuButton} alt="Main Menu" />
          </div>

          <div>
            <Breadcrumb breadcrumb={props.breadcrumb} />
          </div>

          <div className={classes.buttonContainer} onClick={() => setOpenSubmenu(true)}>
            <img src={Meatballs} className={classes.subMenuButton} alt="Main Menu" />

          </div>

          <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
            <Grid container direction="column" alignItems="flex-start">
              <div className={classes.btnContainer}>
                <Grid
                  item
                  className="flexCenter"
                  style={{ justifyContent: "flex-end", marginBottom: "0px" }}
                >
                  <CloseIcon closeFunction={() => setOpen(false)} darkMode={true} />
                </Grid>

              </div>
              {menu.map((item, i) => (
                level <= item.enabled ?
                <div
                  // item
                  key={`item-${i}-${item.name}`}
                  className={`${classes.menuItem} ${item.subpage ? classes.menuItemSubpage : ""}`}
                  onClick={() => {
                    setOpen(false);
                    changeTab(item.url);
                  }}
                >
                  {item.icon ? <div className={classes.iconContainer}><img alt="Menu Icon" src={item.icon} className={classes.menuIcon} /></div> : null}
                  <span>{item.subpage ? "• " : ""}{item.name.toUpperCase()}</span>
                </div>
                :
                null
              ))}
            </Grid>
          </Dialog>

          <Dialog open={openSubmenu} classes={{ paper: classes.dialogPaper }}>
            <Grid container direction="column" alignItems="flex-end">
              <Grid
                item
                className="flexCenter"
                style={{ justifyContent: "flex-end", marginBottom: "0px" }}
              >
                <div className={classes.submenuCloseIconContainer}>
                  <CloseIcon closeFunction={() => setOpenSubmenu(false)} darkMode={true} />
                </div>
              </Grid>
              {submenu.map((item, i) => (
                <Grid
                  item
                  key={`item-${i}-${item.name}`}
                  className={classes.submenuItem}
                  onClick={() => {
                    setOpenSubmenu(false);
                    changeTab(item.url);
                  }}
                >
                  {item.name.toUpperCase()}
                </Grid>
              ))}
            </Grid>
          </Dialog>

        </div>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    breadcrumb: state.common.breadcrumb,
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};
export default connect(mapStateToProps)(withStyles(styles)(withRouter(VMIMobileTopBar)));